<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <MemberBankReportTable/>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import MemberBankReportTable from './MemberBankReportTable.vue'

  export default {
    name: 'memberbankreport-table',
    components: {MemberBankReportTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/report/member/MemberBankReport.vue